// import React, { createContext, useContext, useState } from "react";

// const NotificationContext = createContext();

// export const NotificationProvider = ({ children }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [isLoading, setIsLoading] = useState(true);

//   // Local helper: Mark one as read
//   const markOneAsReadLocal = (id) => {
//     setNotifications((prev) =>
//       prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
//     );
//     setUnreadCount((prev) => Math.max(0, prev - 1));
//   };

//   // Local helper: Mark all as read
//   const markAllAsReadLocal = () => {
//     setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
//     setUnreadCount(0);
//   };

//   // Local helper: Delete one
//   const deleteOneLocal = (id) => {
//     setNotifications((prev) => {
//       const filtered = prev.filter((n) => n._id !== id);
//       // If we delete an unread notification, update the count
//       const deletedItem = prev.find((n) => n._id === id);
//       if (deletedItem && !deletedItem.isRead) {
//         setUnreadCount((count) => Math.max(0, count - 1));
//       }
//       return filtered;
//     });
//   };

//   const clearAllLocal = () => {
//     setNotifications([]);
//     setUnreadCount(0);
//   };

//   return (
//     <NotificationContext.Provider
//       value={{
//         notifications,
//         setNotifications,
//         unreadCount,
//         setUnreadCount,
//         isLoading,
//         setIsLoading,
//         markOneAsReadLocal,
//         markAllAsReadLocal,
//         deleteOneLocal,
//         clearAllLocal,
//       }}
//     >
//       {children}
//     </NotificationContext.Provider>
//   );
// };

// export const useNotifications = () => {
//   const context = useContext(NotificationContext);
//   if (!context) {
//     throw new Error("useNotifications must be used within a NotificationProvider");
//   }
//   return context;
// };
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import axiosInstance from "../api/axiosInstance";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const fetchNotifications = async () => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) {
      setNotifications([]);
      setUnreadCount(0);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const res = await axiosInstance.get("/users/notifications");

      setNotifications(res.data.notifications || []);
      setUnreadCount(res.data.unreadCount || 0);
    } catch (err) {
      console.error("Fetch notifications error:", err);
      setNotifications([]);
      setUnreadCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();

    window.addEventListener("authChange", fetchNotifications);
    return () => window.removeEventListener("authChange", fetchNotifications);
  }, []);

  // helpers (unchanged)
  const markOneAsReadLocal = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
    );
    setUnreadCount((prev) => Math.max(0, prev - 1));
  };

  const markAllAsReadLocal = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
    setUnreadCount(0);
  };

  const deleteOneLocal = (id) => {
    setNotifications((prev) => {
      const filtered = prev.filter((n) => n._id !== id);
      const deletedItem = prev.find((n) => n._id === id);
      if (deletedItem && !deletedItem.isRead) {
        setUnreadCount((count) => Math.max(0, count - 1));
      }
      return filtered;
    });
  };

  const clearAllLocal = () => {
    setNotifications([]);
    setUnreadCount(0);
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        setNotifications,
        unreadCount,
        setUnreadCount,
        isLoading,
        setIsLoading,
        fetchNotifications,
        markOneAsReadLocal,
        markAllAsReadLocal,
        deleteOneLocal,
        clearAllLocal,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
